// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2MuIM","productName":"Table_productName__opxzO"};